import React from "react";

const Loading = () => {
    return (
        <div id={'loading'}>Loading ...</div>
    )
};

export default Loading;